import { Box, Typography } from '@mui/material';
import { getNextAssessment } from '@uplift/api';
import { Spinner, UpliftThemeProvider } from '@uplift/ui-v2';
import { useQuery } from '@tanstack/react-query';
import { Redirect } from 'react-router';

export const NextAssessmentRedirect: React.VFC = () => {
  const { data, isLoading } = useQuery(
    [ 'nextForm' ],
    () => getNextAssessment(null),
    { cacheTime: 0 }
  );

  if (isLoading) {
    return (
      <UpliftThemeProvider>
        <Box height="100vh" display="flex" flexDirection="column" justifyContent="center" alignItems="center" gap="2rem">
          <Spinner />
          <Typography>
            Loading next form...
          </Typography>
        </Box>
      </UpliftThemeProvider>
    );
  }

  if (!data || data.status === 'not_found') {
    return <Redirect to="/main" />;
  }

  return <Redirect to={`/form/submission/${data.submissionId}`} />;
};
